module.exports = "<ngx-loading-bar></ngx-loading-bar>\r\n<router-outlet></router-outlet>\r\n\r\n"